import { render, staticRenderFns } from "./AddSerialNumber.vue?vue&type=template&id=4bf7ed0c&scoped=true&"
import script from "./AddSerialNumber.vue?vue&type=script&lang=js&"
export * from "./AddSerialNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7ed0c",
  null
  
)

export default component.exports